import Vue from 'vue';
import Vuex from "vuex";
import messageInfo from "./messageInfo";
import storage from "./storage";
import loading from "./loading";
import permission from "./permission";
import tagsView from "./tagsView";
import settings from "./settings";
import arrivalConfirm from "./arrivalConfirm";
import units from "./units";
import settlementManage from "./settlementManage";
Vue.use(Vuex);
export default new Vuex.Store({
  state: {
    isLogin: 0,
    examinationSelect: "first",
    collapse: true
  },
  getters: {
    getIsLogin: function getIsLogin(state) {
      return state.isLogin;
    },
    getExaminationSelect: function getExaminationSelect(state) {
      return state.examinationSelect;
    },
    getCollapse: function getCollapse(state) {
      return state.collapse;
    }
  },
  mutations: {
    commitIsLogin: function commitIsLogin(state, isLogin) {
      sessionStorage.setItem("procureIsLogin", 1);
      state.isLogin = isLogin;
    },
    commitExaminationSelect: function commitExaminationSelect(state, select) {
      state.examinationSelect = select;
    },
    commitCollapse: function commitCollapse(state, select) {
      state.collapse = select;
    }
  },
  actions: {
    dispatchIsLogin: function dispatchIsLogin(context, isLogin) {
      context.commit("commitIsLogin", isLogin);
    },
    dispatchExaminationSelect: function dispatchExaminationSelect(context, select) {
      context.commit("commitExaminationSelect", select);
    },
    dispatchCollapseSelect: function dispatchCollapseSelect(context, select) {
      context.commit("commitCollapse", select);
    }
  },
  modules: {
    messageInfo: messageInfo,
    storage: storage,
    loading: loading,
    permission: permission,
    tagsView: tagsView,
    settings: settings,
    arrivalConfirm: arrivalConfirm,
    settlementManage: settlementManage,
    units: units
  }
});